import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BUSINESS } from "../lib/site";

export default function Contact() {
  return (
    <section id="contact" className="relative py-24 sm:py-32 border-t border-white/5 bg-[#0A0A0A]" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="mb-16">
          <div className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-500 mb-4">
            [ 08 ] · CONTACT
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tighter">
            Local. Reachable. <span className="text-[#0055FF]">Real.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-zinc-800">
          <div className="bg-[#121212] p-8 lg:p-10" data-testid="contact-address">
            <MapPin className="w-5 h-5 text-[#0055FF] mb-6" />
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-3">Drop-off / Ship-in</div>
            <div className="font-display text-xl mb-2">67 Grand St</div>
            <div className="text-zinc-400">Susquehanna, PA 18847</div>
          </div>

          <div className="bg-[#121212] p-8 lg:p-10" data-testid="contact-phone-email">
            <Phone className="w-5 h-5 text-[#0055FF] mb-6" />
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-3">Direct line</div>
            <a href={BUSINESS.phoneHref} className="font-display text-xl block mb-2 hover:text-[#0055FF] transition-colors">
              {BUSINESS.phone}
            </a>
            <a href={BUSINESS.emailHref} className="text-zinc-400 hover:text-white transition-colors flex items-center gap-2">
              <Mail className="w-4 h-4" /> {BUSINESS.email}
            </a>
          </div>

          <div className="bg-[#121212] p-8 lg:p-10" data-testid="contact-hours">
            <Clock className="w-5 h-5 text-[#0055FF] mb-6" />
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-3">Hours</div>
            <div className="space-y-1.5">
              {BUSINESS.hours.map((h) => (
                <div key={h.day} className="flex justify-between text-sm">
                  <span className="text-zinc-400">{h.day}</span>
                  <span className="text-white font-medium">{h.time}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 rounded-md overflow-hidden border border-zinc-800">
          <iframe
            title="Tombs Electronic Repair location"
            src="https://www.google.com/maps?q=67+Grand+St,+Susquehanna,+PA+18847&output=embed"
            className="w-full h-72 grayscale-[30%] contrast-110"
            loading="lazy"
            data-testid="contact-map"
          />
        </div>
      </div>
    </section>
  );
}
